import { defineMessages } from 'react-intl';

export const locationSelectorMessages = defineMessages({
  'locationSelector:fetchingYourLocationLabel': {
    id: 'locationSelector:fetchingYourLocationLabel',
    defaultMessage: 'Fetching your location...',
    description: "Message displayed when the app is fetching the user's current location.",
  },
  'locationSelector:showingNearbyOffersLabel': {
    id: 'locationSelector:showingNearbyOffersLabel',
    defaultMessage: 'Showing nearby offers',
    description: "Label indicating that offers are being shown based on the user's nearby location.",
  },
  'locationSelector:showingAllOffersLabel': {
    id: 'locationSelector:showingAllOffersLabel',
    defaultMessage: 'Showing all offers',
    description: 'Label indicating that all offers are being shown regardless of location.',
  },
});
